export default [
  {
    nome: 'Ouvidoria',
    icon: 'comments',
    permissao: 'VIEW_CAIXA_OUVIDORIA',
    routeName: 'ouvidoria/home'
  },
  {
    nome: 'Gestão de Conflitos',
    icon: 'file-alt',
    permissao: 'VIEW_CAIXA_GESTAO_CONFLITOS',
    routeName: 'ouvidoria/gestao-conflitos'
  }
]



// WEBPACK FOOTER //
// ./src/screens/ouvidoria/menu.js